/**
 * MD-13 FE-DOCPACK — Day-1 Doc Pack catalog
 *
 * Mirrors MD-12 Shortcut SKUs that have Doc Pack upsell + a few SME/citizen
 * extras. Modifications require marketer + legal-upl review.
 */

import type { DocPackSku, Lang } from './types';

export const DOCPACK_CATALOG: DocPackSku[] = [
  {
    sku: 'TRC_PACK',
    title_vn: 'Doc Pack — Gia hạn TRC',
    title_en: 'Doc Pack — TRC Renewal',
    description_vn: 'Hồ sơ gia hạn TRC đầy đủ + biểu mẫu + checklist + citation Điều/Khoản.',
    description_en: 'Full TRC renewal kit: forms, checklist, Article/Clause citations.',
    price_vnd: 199000,
    price_usd: 19,
    segment: 'expat',
    est_pages: 12,
    section_count: 7,
  },
  {
    sku: 'WP_CHANGE_PACK',
    title_vn: 'Doc Pack — Đổi loại Work Permit',
    title_en: 'Doc Pack — Work Permit Change',
    description_vn: 'Thủ tục đổi WP: hồ sơ, biểu mẫu, timeline, citation chi tiết.',
    description_en: 'Work permit change: paperwork, forms, timeline, detailed citations.',
    price_vnd: 199000,
    price_usd: 19,
    segment: 'expat',
    est_pages: 10,
    section_count: 6,
  },
  {
    sku: 'HDLD_TEMPLATE_PACK',
    title_vn: 'Doc Pack — Mẫu HĐLĐ + Hướng dẫn',
    title_en: 'Doc Pack — Employment Contract Templates + Guide',
    description_vn: '6 mẫu HĐLĐ + hướng dẫn điều khoản + checklist tuân thủ Bộ luật Lao động.',
    description_en: '6 employment contract templates + clause guide + compliance checklist.',
    price_vnd: 299000,
    price_usd: 29,
    segment: 'sme',
    est_pages: 18,
    section_count: 8,
  },
  {
    sku: 'GPDKKD_SETUP_PACK',
    title_vn: 'Doc Pack — Thiết lập GPĐKKD',
    title_en: 'Doc Pack — Business Registration Setup',
    description_vn: 'Hồ sơ đăng ký kinh doanh đầy đủ + biểu mẫu + lệ phí cập nhật.',
    description_en: 'Business registration paperwork: forms, fees, citations.',
    price_vnd: 299000,
    price_usd: 29,
    segment: 'sme',
    est_pages: 16,
    section_count: 8,
  },
  {
    sku: 'DIVORCE_PACK',
    title_vn: 'Doc Pack — Đơn ly hôn',
    title_en: 'Doc Pack — Divorce Petition',
    description_vn: 'Đơn ly hôn thuận tình + tranh chấp + tài sản + nuôi con + citation Luật HN&GĐ.',
    description_en: 'Divorce petition (consensual + contested) + assets + custody + citations.',
    price_vnd: 199000,
    price_usd: 19,
    segment: 'citizen',
    est_pages: 14,
    section_count: 7,
  },
];

export function listDocPacks(_lang: Lang): DocPackSku[] {
  return DOCPACK_CATALOG;
}

export function findDocPack(sku: string): DocPackSku | null {
  return DOCPACK_CATALOG.find((s) => s.sku === sku) ?? null;
}

export function pricingFor(sku: DocPackSku, currency: 'VND' | 'USD'): { amount: number; display: string } {
  if (currency === 'VND') {
    return { amount: sku.price_vnd, display: `${sku.price_vnd.toLocaleString('vi-VN')} đ` };
  }
  return { amount: sku.price_usd, display: `$${sku.price_usd}` };
}
